import React, { Component } from 'react'
import { Dropdown } from '@softwaredev_cegeka/stix-core'
import { Select } from '@softwaredev_cegeka/stix-form-select'
import { Observer } from 'mobx-react'
import { authenticatedUserStore } from 'src/stores'
import AuthenticatedUserStore from 'src/stores/AuthenticatedUserStore'
import './organizationMenu.scss'

const { ORGANIZATION } = AuthenticatedUserStore.IMPERSONATE

export default class OrganizationMenu extends Component {
    componentDidMount() {
        if (
            !authenticatedUserStore.loading[ORGANIZATION] &&
            !authenticatedUserStore.isLocalUser
        ) {
            authenticatedUserStore.loadUserOrganizations()
        }
    }

    getOrganizations() {
        return authenticatedUserStore.userOrganizations.map(organization => ({
            value: organization.organization_id,
            label: organization.name,
            id: organization.id,
        }))
    }

    handleOrganizationChange(chosen) {
        if (!chosen) {
            authenticatedUserStore.stopImpersonateOrganization()
        } else {
            authenticatedUserStore.impersonateOrganization(chosen)
        }
    }

    render() {
        return !authenticatedUserStore.isLocalUser ? (
            <Observer>
                {() => (
                    <>
                        <Dropdown.Header>Change Organization</Dropdown.Header>
                        <Select
                            label="Filter organizations"
                            srOnly
                            options={this.getOrganizations()}
                            isSearchable
                            isClearable
                            menuIsOpen
                            value={
                                authenticatedUserStore.impersonated[
                                    ORGANIZATION
                                ]
                            }
                            onChange={this.handleOrganizationChange}
                            placeholder={'Filter organizations'}
                        />
                    </>
                )}
            </Observer>
        ) : null
    }
}
